import Client from '../hooks/useAxios';

export const getStatus = async () => {
  const response = await Client().get('/auth/status');
  return response.data;
};

export const getGuest = async () => {
  const response = await Client().get('/guest');
  return response.data;
};

export const getGuestSlice = async (page) => {
  const response = await Client().get('/guest/'+ page);
  return response.data;
};
export const getGuestSingle = async (id) => {
  const response = await Client().get('/guest/single/'+ id);
  return response.data;
};
export const getGuestReports = async () => {
  const response = await Client().get('/guest/reports');
  return response.data;
};